import React from 'react';
import { useIsWebView } from '@/hooks/useIsWebView';

export function withNativeAware(NativeComponent, WebComponent) {
  return function NativeAwareComponent(props) {
    const isNative = useIsWebView();
    return isNative ? (
      NativeComponent ? (
        <NativeComponent {...props} />
      ) : (
        <></>
      )
    ) : WebComponent ? (
      <WebComponent {...props} />
    ) : (
      <></>
    );
  };
}
